// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.student-info-tabs .ant-tabs-tab.ant-tabs-tab-active {
  background-color: #703895 !important;
}

.student-info-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #ffffff !important;
}

.student-info-tabs [data-student-info-tab-label] {
  display: inline-block;
  padding: 2px 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Student/Student.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB","sourcesContent":[".student-info-tabs .ant-tabs-tab.ant-tabs-tab-active {\n  background-color: #703895 !important;\n}\n\n.student-info-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #ffffff !important;\n}\n\n.student-info-tabs [data-student-info-tab-label] {\n  display: inline-block;\n  padding: 2px 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
